import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable({
  providedIn: 'root'
})
export class BuildInfoService {

  constructor(private http: HttpClient, private headerService: HeaderService) {}

  getBuildVersion() {
    const url = `${environment.rootApiUrl}/common/versionInfo`;
    return this.http.get(url, {headers: this.headerService.getXAuthHeaderFromCookie(), responseType: 'text'});
  }

}
